export const humanFileSize = (size: number) => {
  const counter = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return (
    Number((size / Math.pow(1024, counter)).toFixed(2)) +
    ' ' +
    ['B', 'KB', 'MB', 'GB', 'TB'][counter]
  );
};
